import { getAddressFields } from "../customerAddressFields";

/** Fills the primary address fields from the account's address number 1. */
export function adaptAccountRecord(
  record: Record<string, unknown>
): Record<string, unknown> {
  const primaryAddress = getAddressFields(record, "1");

  return primaryAddress ? { ...record, ...primaryAddress } : record;
}
